module.exports = __webpack_public_path__ + "static/media/1.5d1da5df.jpg";